import getPitch from './pitch-detection';
import p5 from 'p5';
import 'p5/lib/addons/p5.sound';
import 'p5/lib/addons/p5.dom';

import {drawWaterColorBrush} from './watercolor';

export default function sketch(p) {
  const BACKGROUND = '#111';
  let source, fft, lowPass;
  let amplitude;
  let brush = watercolorBrush;
  let noteName;
  let targetFrequency;

  function frequencyToColor(freq) {
    const COLORS = [
      '#FF0001',
      '#FF4401',
      '#D66F01',
      '#FFC503',
      '#E0EA03',
      '#76D102',
      '#01FFAB',
      '#00FFE7',
      '#00B2FF',
      '#3409FF',
      '#9E07FF',
      '#FF03FD',
    ];
    const NOTE_FREQUENCIES = [
      16.35,
      17.32,
      18.35,
      19.45,
      20.6,
      21.83,
      23.12,
      24.5,
      25.96,
      27.5,
      29.14,
      30.87,
    ];
    let i = 0;
    let j = 0;
    while (i < 200) {
      NOTE_FREQUENCIES.push(NOTE_FREQUENCIES[j] * 2);
      j++;
      i++;
    }
    const NOTES = [
      'C',
      'C#',
      'D',
      'D#',
      'E',
      'F',
      'F#',
      'G',
      'G#',
      'A',
      'A#',
      'B',
    ];

    const level = amplitude.getLevel();
    if (level < 0.001) {
      return 'black';
    }

    // const nfreq = normalizeToFit(NOTE_FREQUENCIES, freq);
    p.fill(0);
    // text ('Estimated Low Frequency: ' + nfreq.toFixed(2), 20, 20);
    const note = findClosest(NOTE_FREQUENCIES, freq);
    const index = NOTE_FREQUENCIES.indexOf(note);
    const nindex = index % COLORS.length;
    const color = COLORS[nindex];
    noteName = NOTES[nindex];
    targetFrequency = note;

    return color;
  }

  function findClosest(arr, value) {
    const distances = arr.map(v => Math.abs(v - value));
    const mindist = p.min(distances);
    return arr[distances.indexOf(mindist)];
  }

  function watercolorBrush({level, spectrumColor, x, y}) {
    drawWaterColorBrush(p, x, y, level * 800, spectrumColor);
  }

  function colorAlpha(aColor, alpha) {
    var c = p.color(aColor);
    return p.color(
      'rgba(' + [p.red(c), p.green(c), p.blue(c), alpha].join(',') + ')',
    );
  }

  let edge = 0;
  function drawTree(n, x, y, size, spectrumColor, level) {
    edge = 0;
    drawBranch(
      n,
      x + p.random(-10, 10),
      y,
      size,
      p.PI / 2 + p.random(-0.2, 0.2),
      spectrumColor,
      level,
    );
  }

  function drawBranch(n, x, y, size, angle, spectrumColor, level) {
    if (n < 0 && new Date().getTime() % 242 === edge) {
      brush({
        level: level,
        spectrumColor,
        x,
        y,
      });
      edge += 1;
      return;
    }
    if (n < 0) {
      edge += 1;
      return;
    }

    const x2 = x + p.cos(angle) * size;
    const y2 = y - p.sin(angle) * size;

    p.stroke(colorAlpha(spectrumColor, 0.01));
    p.line(x, y, x2, y2);
    // p.stroke(colorAlpha('white', 0.1));
    // p.line(x, y, x2, y2);

    drawBranch(
      n - 1,
      x2,
      y2,
      size * 0.7,
      angle - p.PI / 5 + p.random(-0.4, 0.4),
      spectrumColor,
      level,
    );
    drawBranch(
      n - 1,
      x2,
      y2,
      size * 0.7,
      angle + p.random(-0.4, 0.4),
      spectrumColor,
      level,
    );
    drawBranch(
      n - 1,
      x2,
      y2,
      size * 0.7,
      angle + p.PI / 5 + p.random(-0.4, 0.4),
      spectrumColor,
      level,
    );
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function myCustomRedrawAccordingToNewPropsHandler(
    props,
  ) {};

  p.setup = function setup() {
    console.log('creating canvas');
    p.createCanvas(p.windowWidth, p.windowHeight);
    p.noFill();

    // uncomment me to use mic
    source = new p5.AudioIn();
    source.start();

    // source.play(); // comment me to use mic

    amplitude = new p5.Amplitude();
    amplitude.setInput(source);

    lowPass = new p5.LowPass();
    lowPass.disconnect();
    source.connect(lowPass);

    fft = new p5.FFT();
    fft.setInput(lowPass);

    p.background(BACKGROUND);

    // const squareBrushButton = p5.createButton('Square Brush');
    // squareBrushButton.position(p.width - 100, p.height - 20);
    // squareBrushButton.mousePressed(() => (brush = squareBrush));
    // const circleBrushButton = p5.createButton('Circle Brush');
    // circleBrushButton.position(p.width - 100, p.height - 40);
    // circleBrushButton.mousePressed(() => (brush = circleBrush));
  };

  let storedEllipses = [];
  p.draw = function draw() {
    p.background(colorAlpha(BACKGROUND, 0.01));

    p.noFill();

    const timeDomain = fft.waveform(1024, 'float32');
    const freq = getPitch(p, timeDomain);
    const spectrumColor = frequencyToColor(freq);
    const level = amplitude.getLevel();

    p.onChange &&
      p.onChange({
        frequency: freq,
        spectrumColor,
        targetFrequency,
        noteName,
        level,
      });

    p.noStroke();
    // p.stroke(255)

    drawTree(
      3,
      p.width / 2,
      p.height - 200,
      100 + level * 600,
      spectrumColor,
      level,
    );

    // brush({
    //   level: level * 2,
    //   spectrumColor,
    //   x: p.width / 2,
    //   y: p.height / 2,
    // });
  };

  p.touchStarted = function touchStarted() {
    p.getAudioContext().resume();
  };
}



// WEBPACK FOOTER //
// ./src/sketches/trees.js